import useWindowSize from 'components/util/useWindowSize'
import RightRobotCard from 'components/cards/new/common/RightRobotCard'

const features = [
  {
    description: 'Aligned with AU regulatory expectations',
    title: 'KYC/AML',
  },
  {
    description: 'End-to-end encryption, AU privacy compliant',
    title: 'Data Security',
  },
  {
    description: 'Cyber Essentials Plus (UK), adapted locally',
    title: 'Certifications',
  },
  {
    description: 'SLAs, T&Cs, data policies, onboarding checklists',
    title: 'Documentation Available',
  },
]

const SecureCompliantAndTransparent = ({}) => {
  const size = useWindowSize()

  return (
    <RightRobotCard
      image={{
        alt: 'Robot arm pointing left for security',
        desktop: {
          dimensions: {
            height: 276,
            width: 782,
          },
          src: '/images/new/arm-pointing-left.png',
        },
        mobile: {
          dimensions: {
            height: 0,
            width: 0,
          },
          src: 'none',
        },
      }}
      imageContainerWidth={'50%'}
      reverseColumnOrder
      overrideAllImageStyles
      imageStyle={{
        maxHeight: '100%',
        objectFit: 'contain',
        top: 0,
        width: '100%',
      }}
    >
      <div
        className='d-flex flex-column flex-1 px-4 pb-8 py-lg-15 ps-lg-20 pt-6'
        style={{
          marginRight: size.isLgOrHigher ? '-10%' : '0px',
        }}
      >
        <h1
          className='fs-fluid-36-52 lh-105 fw-semibold mb-4'
          style={{ maxWidth: 462 }}
        >
          Secure, Compliant & Transparent
        </h1>
        <div className='d-flex flex-column gap-4'>
          {features.map((feature, index) => (
            <span className='fs-fluid-20-26 lh-119 fw-bold fw-semibold'>
              <strong>{feature.title}:</strong> {feature.description}
            </span>
          ))}
        </div>
      </div>
    </RightRobotCard>
  )
}

export default SecureCompliantAndTransparent
